import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { TaxesFacade } from "@modules/taxes/domain/+state/taxes.facade";
import { map, take } from "rxjs/operators";
import { Observable } from "rxjs";
import { TinVerificationState } from "@modules/taxes/domain/infrastructure/taxes.remote";
import { InfoService } from "@core-services/info.service";
import { TranslationService } from "@core-services/translation.service";

@Injectable({ providedIn: "root" })
export class TinShieldEntryHelper {
	private readonly router = inject(Router);
	private taxesFacade = inject(TaxesFacade);
	private infoService = inject(InfoService);
	private translationService = inject(TranslationService);

	private openTinShield(queryParams): void {
		// TODO: in case queryParams need to be passed to V4, this is needed, otherwise can be removed
		this.router.navigate([{ outlets: { [ROUTER_OUTLET_NAME]: ["tin", "tin-shield"] } }], { queryParams });
	}

	// TODO: does it need error handling, at the moment on api error withdraw flows are not blocked
	handleTinStatusCheck$(): Observable<boolean> {
		return this.taxesFacade.getTinVerificationStatus$().pipe(
			take(1),
			map((tinResponse) => {
				if (tinResponse?.hasError) {
					return true;
				}

				const isFrozen =
					tinResponse?.status === TinVerificationState.OnHold ||
					tinResponse?.status === TinVerificationState.Pending;
				const isInReview = tinResponse?.status === TinVerificationState.InReview;

				if (isInReview) {
					const title = this.translationService.translate("tin_status_in_review_toast_title");
					const message = this.translationService.translate("tin_status_in_review_toast_subtitle");
					this.infoService.setInfo(message, title);
					return false;
				}
				if (!isFrozen) {
					return false;
				}
				this.openTinShield(null);
				return true;
			})
		);
	}
}
